export interface NotificationBannerModel {
  noticeBannerELem?: HTMLElement | null;
  init: () => void;
  setProperty: () => void;
}

(() => {
  const notificationBanner: NotificationBannerModel = {
    noticeBannerELem: document.querySelector<HTMLDivElement>('.fm-o-notification-banner'),
    init() {
      if (!this.noticeBannerELem) {
        return;
      }

      this.noticeBannerELem.observeResize(this.setProperty.bind(this));
    },
    setProperty() {
      if (this.noticeBannerELem) {
        document.body.style.setProperty("--notice-banner-height", this.noticeBannerELem.clientHeight + "px");
      }
    }
  };

  notificationBanner.init();
})();